import classNames from "classnames";
import Footer from "../../Component/Footer/Footer";
import Navbar from "../../Component/Navbar/Navbar";
import SubTitle from "../../Component/Text/SubTitle";

const NewsInfo = (title,date,content,img1) => {
  return (
    <div>
      <Navbar />
      <div
        className={classNames("container")}
        style={{ paddingTop: "8vh", minHeight: "60vh" }}
      >
        <SubTitle text={title} />
        <p
          style={{ color: "#5e5e5e", marginBottom: "1vh", textAlign: "right" }}
        >
          {date}
          
        </p>
        <div
          style={{
            color: "#5e5e5e",
            marginBottom: "1vh",
            textAlign: "justify",
            fontSize:"2vh",
            letterSpacing:"0.2vh",
            lineHeight:"4vh",
            display: "flex",
            justifyContent: "center",
          }}
        >
          <div
            style={{ color: "#5e5e5e", marginBottom: "2vh", maxWidth: "100vh" }}
          >
            <div >
                {content}
            </div>
          </div>
        </div>
        <img
          src={img1}
          alt="img.png"
          style={{ width: "40vh", height: "auto", marginBottom: "2vh" }}
        ></img>
      </div>
      <div>
        <Footer />
      </div>
    </div>
  );
};
export default NewsInfo;
